import * as React from "react";
import styled from "styled-components";
import { alertGeneral, alertHeading, alertIcon } from "../../components/StyledContent/alerts";
export function Alert(a) {
  var b = a.variant,
      c = a.header,
      d = a.content,
      e = a.className,
      f = a.style,
      g = a.children;
  return g || d ? /*#__PURE__*/React.createElement(AlertWrapper, {
    variant: b || "attention",
    className: e,
    style: f
  }, /*#__PURE__*/React.createElement("div", null, c && /*#__PURE__*/React.createElement(AlertHeader, {
    variant: b
  }, c), /*#__PURE__*/React.createElement(AlertText, {
    variant: b
  }, g || d))) : null;
}

function getVariant(a, b) {
  return a.components.alert.variants[b];
}

var AlertWrapper = styled.div.withConfig({
  displayName: "Alert__AlertWrapper",
  componentId: "v3d98e-0"
})(["", " display:flex;background-color:", ";&::before{", ";}"], alertGeneral, function (_ref) {
  var a = _ref.theme,
      b = _ref.variant;
  return getVariant(a, b).backgroundColor;
}, alertIcon),
    AlertHeader = styled.h5.withConfig({
  displayName: "Alert__AlertHeader",
  componentId: "v3d98e-1"
})(["", ""], alertHeading),
    AlertText = styled.p.withConfig({
  displayName: "Alert__AlertText",
  componentId: "v3d98e-2"
})(["display:block;width:100%;margin:0;padding:0;color:", ";line-height:1.5;font-size:16px;"], function (_ref2) {
  var a = _ref2.theme,
      b = _ref2.variant;
  return getVariant(a, b).textColor;
});